<template>
  <SysDialog
    v-model="dialog_ativo"
    persistent
    transition="dialog-top-transition"
  >
    <template #ativador="{ callback }">
      <slot name="ativador" :callback="callback">
        <v-btn
          class="mr-5"
          color="secondary"
          @click="callback"
        >
          <v-icon left>mdi-plus</v-icon>
          Configuração por Filial
        </v-btn>
      </slot>
    </template>

    <template #titulo>
      <span>{{ editando ? "Editando" : "Cadastrando" }}</span>

      <v-spacer/>

      <v-btn icon @click="fecharDialog" class="ml-n2">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>

    <div>
      <div>
        <SysProdutoAutocomplete
          v-model="editedItem.produtos"
          label="Selecione o Produto*"
          outlined
          multiple
          :force-busca="String(itemParaEdicao.idproduto || '').length > 0 ? [itemParaEdicao.idproduto] : []"
          :disabled="editedItem.id > 0"
          :error-messages="produtosErros"
          @change="messageError = null"
        />

        <text-field-formatador
          v-model="editedItem.tempo_cobertura"
          label="Tempo de Cobertura Geral*"
          outlined
          inteiro
          :remover-valor-irrelevante="true"
          suffix="dias"
          messages="Ao informar a cobertura aqui, a ação será aplicada a todas as filiais selecionadas."
          @focus="$event.target.select()"
          @keyup.enter="salvar()"
          @keyup="aplicarTempoGeral"
        />
      </div>

      <div class="mt-6">
        <p class="ma-0 font-14 font-weight-medium mb-2">
          Lista de Filiais ({{ filiaisSelecionadas.length }} selecionadas)
        </p>

        <v-card elevation="0" outlined>
          <v-data-table
            v-model="filiaisSelecionadas"
            :items="filiais"
            :headers="[
              { text: 'Filial', value: 'filial'},
              { text: 'Tempo de Cobertura', value: 'tempo_cobertura'},
            ]"
            show-select
            hide-default-footer
            item-key="descricao"
            checkbox-color="primary"
            height="calc(100vh - 500px)"
            :items-per-page="-1"
          >
            <template #item.filial="{ item }">
              {{ item.descricao }}
            </template>

            <template #item.tempo_cobertura="{ item }">
              <div class="py-2 pr-3" style="width: 150px">
                <text-field-formatador
                  v-model="item.tempo_cobertura"
                  outlined
                  dense
                  inteiro
                  hide-details
                  class="filial-tempo-field w-full"
                  suffix="dias"
                  :remover-valor-irrelevante="true"
                  @focus="$event.target.select()"
                />
              </div>
            </template>
          </v-data-table>
        </v-card>

        <div v-if="filiaisErros.length" class="error--text caption mt-2">
          {{ filiaisErros[0] }}
        </div>
      </div>

      <div v-if="messageError" class="error--text caption mt-2">
        {{ messageError }}
      </div>
    </div>

    <template #actions>
      <v-btn text color="primary" @click="salvar()">salvar</v-btn>
    </template>
  </SysDialog>
</template>

<script>
import TextFieldFormatador from "../../../../utils/TextFieldFormatadorDeValor.vue";

import { required } from "vuelidate/lib/validators";
import api from "@/api/api";
import { toast2 } from "@/components/utils/ui_v4/alerts/toast/toast2";
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";
import SysProdutoAutocomplete from "@/components/utils/crud/SysProdutoAutocomplete.vue";

export default {
  name: "DialogCurvasProdutosFilial",
  components: {
    SysDialog,
    TextFieldFormatador,
    SysProdutoAutocomplete,
  },
  props: {
    itemParaEdicao: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['atualizacao', 'dialog:fechado'],
  data: () => ({
    messageError: null,
    editedItem: {
      id: "",
      produtos: [],
      tempo_cobertura: "",
    },
    filiais: [],
    filiaisSelecionadas: [],
    temposPorFilial: {},
    dialog_ativo: false,
  }),
  validations: {
    editedItem: {
      produtos: {
        required,
      },
    },
    filiaisSelecionadas: {
      required,
      tempo_cobertura() {
        return this.filiaisSelecionadas.every(item => Number(item.tempo_cobertura) >= 0);
      }
    },
  },
  computed: {
    editando() {
      return Number(this.itemParaEdicao.idproduto || 0) > 0;
    },
    produtosErros() {
      const errors = [];
      if (!this.$v.editedItem.produtos.$dirty) return errors;

      if (!this.$v.editedItem.produtos.required) {
        errors.push("Campo Obrigatório.");
      }

      return errors;
    },
    filiaisErros() {
      const errors = [];
      if (!this.$v.filiaisSelecionadas.$dirty) return errors;

      if (!this.$v.filiaisSelecionadas.required) {
        errors.push("Selecione ao menos uma filial.");
      }

      if (!this.$v.filiaisSelecionadas.tempo_cobertura) {
        errors.push("Informe o Tempo de Cobertura para as filiais selecionadas.");
      }

      return errors;
    },
  },
  watch: {
    dialog_ativo() {
      if (!this.dialog_ativo) {
        this.$emit('dialog:fechado', {})
        return;
      }

      this.buscarFiliais();
    },
    filiaisSelecionadas() {
      this.filiaisSelecionadas.forEach(item => {
        if (Number(item.tempo_cobertura) > 0) {
          return;
        }

        item.tempo_cobertura = Number(this.editedItem.tempo_cobertura);
      });
    }
  },
  methods: {
    buscarFiliais() {
      api.get('/grupo/filiais')
        .then(response => {
          this.filiais = this.removerFiliaisDuplicadas(response.data.filiais);
        })
        .catch(() => toast2.error('Falha ao buscar as filiais para seleção.'))
        .finally(this.selecionarDadosEdicao);
    },
    removerFiliaisDuplicadas(filiais) {
      return Array.from(
        new Map(
          filiais.map(item => [
            item.id,
            {
              id: item.id,
              descricao: item.descricao,
              tempo_cobertura: 0,
            }
          ])
        ).values());
    },
    selecionarDadosEdicao() {
      if (!Number(this.itemParaEdicao.idproduto)) {
        return;
      }

      this.editedItem.produtos = [String(this.itemParaEdicao.idproduto)];

      this.filiaisSelecionadas = this.filiais
        .filter(item => this.itemParaEdicao.tempo_cobertura_por_filial.some(i => i.filial === item.id));

      this.filiaisSelecionadas.forEach(item => {
        const item_edicao = this.itemParaEdicao.tempo_cobertura_por_filial.find(i => i.filial === item.id);
        item.tempo_cobertura = item_edicao.tempo_cobertura;
      });

      this.editedItem.tempo_cobertura = Number(Math.max(...this.itemParaEdicao.tempo_cobertura_por_filial.map(item => item.tempo_cobertura)));
    },
    aplicarTempoGeral() {
      this.filiaisSelecionadas.forEach(item => {
        item.tempo_cobertura = this.editedItem.tempo_cobertura;
      });
    },
    salvar() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      const existe_filiais_cobertura_zero = this.filiaisSelecionadas.find((i) => i.tempo_cobertura <= 0);
      if (existe_filiais_cobertura_zero) {
        this.messageError = 'O Tempo de Cobertura precisa ser maior que zero(0).'
        return;
      }

      const parametros = {
        produtos: this.editedItem.produtos,
        filiais: this.filiaisSelecionadas.map(item => ({
          id: item.id,
          tempo_cobertura: item.tempo_cobertura,
        })),
      };

      api.post('compras/cobertura-por-excecao/produtos/filiais', parametros)
        .then(() => {
          this.fecharDialog();
          this.$emit("atualizacao", true);
        })
        .catch(() => this.Helpers.logout())
    },
    resetFormulario() {
      this.editedItem = {
        id: "",
        produtos: [],
        tempo_cobertura: "",
      };

      this.filiaisSelecionadas = [];
      this.temposPorFilial = {};
      this.messageError = null;
    },
    fecharDialog() {
      this.dialog_ativo = false;
      this.$v.$reset();
      this.resetFormulario();
    },
  },
};
</script>
